__turbopack_context__.v({
  "cta": "component-header-module-scss-module__DRFWnW__cta",
  "description": "component-header-module-scss-module__DRFWnW__description",
  "title": "component-header-module-scss-module__DRFWnW__title",
  "titleAndLinkWrapper": "component-header-module-scss-module__DRFWnW__titleAndLinkWrapper",
  "wrapper": "component-header-module-scss-module__DRFWnW__wrapper",
});
